import React from 'react';
import psicologiaImage from '../../assets/images/servicos/psicoterapia.jpg';

const PsicologiaInfantil = () => {
    return (
        <>
            <section className="breadcrumb-section">
                <div className="container">
                    <h1>Psicologia Infantil</h1>
                    <div className="breadcrumb">
                        <a href="/home">Home</a>
                        <span className="fa fa-angle-double-right"></span>
                        <span className="current">Psicologia Infantil</span>
                    </div>
                </div>
            </section>

            <div id="main">
                <div className="container">
                    <section id="primary" className="with-sidebar">
                        <article className="blog-entry">
                            <div className="blog-entry-inner">
                                <div className="entry-thumb">
                                    <img src={psicologiaImage} alt="Psicologia Infantil" />
                                </div>
                                <div className="entry-details">
                                    <div className="entry-title">
                                        <h3> Cuidando da Saúde Emocional das Crianças e Adolescentes </h3>
                                    </div><br />
                                    <div className="entry-body">
                                        <p>A psicologia infantojuvenil é fundamental para o desenvolvimento saudável de crianças e adolescentes, ajudando-os a lidar com os desafios emocionais, comportamentais e sociais que surgem em diferentes fases da vida. Nossos serviços de psicologia infantojuvenil oferecem um espaço seguro e acolhedor para que os jovens possam expressar suas emoções, desenvolver habilidades emocionais e superar dificuldades de forma saudável.</p><br />
                                        <p>Nossa equipe de psicólogos especializados em infância e adolescência trabalha de maneira integrada com as famílias, escolas e outros profissionais da saúde, promovendo intervenções terapêuticas personalizadas para atender às necessidades de cada criança ou adolescente.</p><br />
                                        <p>Nosso compromisso é oferecer um cuidado integral à saúde emocional das crianças e adolescentes, auxiliando-os a enfrentar os desafios dessa fase da vida de forma equilibrada e saudável. Acreditamos que, com o suporte adequado, cada jovem pode crescer emocionalmente forte, preparado para lidar com as adversidades e alcançar seu pleno potencial.</p>
                                    </div>
                                </div>
                            </div>
                        </article>
                    </section>

                    <section id="secondary">
                        <aside className="widget widget_text">
                            <h3 className="widgettitle">Nossos serviços incluem</h3>
                            <p><b>Terapia Individual para Crianças e Adolescentes:</b><br /> Atendimento psicológico focado em questões como ansiedade, depressão, estresse, problemas de comportamento, transtornos alimentares, dificuldades escolares e desafios de relacionamento social.</p><br />
                            <p><b>Apoio ao Desenvolvimento Emocional</b><br /> Intervenções que ajudam a criança ou adolescente a compreender e lidar com suas emoções, fortalecendo a autoestima, a resiliência e as habilidades sociais.</p><br />
                            <p><b>Tratamento de Transtornos Psicológicos</b><br /> Diagnóstico e tratamento de transtornos como TDAH, transtornos de ansiedade, transtorno do espectro autista (TEA), depressão infantil, entre outros.</p><br />
                            <p><b>Orientação Parental</b><br /> Apoio e orientação aos pais, ajudando-os a compreender as necessidades emocionais de seus filhos e a adotar estratégias para promover um ambiente familiar saudável e equilibrado. E com Intervenções terapêuticas voltadas para a dinâmica familiar, abordando conflitos e promovendo a melhoria da comunicação e dos relacionamentos dentro da família.</p><br />
                        </aside>
                    </section>
                </div>
            </div>
        </>
    );
};

export default PsicologiaInfantil;
